var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#E3F2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5002 71.927H29.5586V65.2H79.5002V71.927Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1799 65.2334H28.9648V48.6152H36.1799V65.2334Z",
    fill: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6914 65.2334H35.9075V71.925H28.6914V65.2334Z",
    fill: "#0770BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7148 65.2334H79.4969V71.925H71.7148V65.2334Z",
    fill: "#B0DDFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8631 32.3008H79.5007V72.6752H28.6914V48.6142",
    stroke: "#2C426B",
    strokeWidth: 1.54376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6166 55.4941H67.2695V47.146H75.6166",
    stroke: "#2C426B",
    strokeWidth: 1.54376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.875 25.8937L72.225 20.5042L72.3425 29.1813",
    stroke: "#2C426B",
    strokeWidth: 1.54376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5532 51.3197C72.5532 52.32 72.057 53.131 71.4465 53.131C70.835 53.131 70.3398 52.32 70.3398 51.3197C70.3398 50.3193 70.835 49.5083 71.4465 49.5083C72.057 49.5083 72.5532 50.3193 72.5532 51.3197Z",
    fill: "#2C426B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2518 34.9071C26.2518 33.282 26.7024 31.7683 27.479 30.4673C25.0864 32.0184 23.5039 34.7056 23.5039 37.7694C23.5039 42.5768 27.4 46.4749 32.2074 46.4749C35.3937 46.4749 38.171 44.7597 39.6867 42.2082C38.3269 43.0921 36.7039 43.6126 34.9583 43.6126C30.1479 43.6126 26.2518 39.7144 26.2518 34.9071Z",
    fill: "#EAEAEA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.12 37.2904C41.12 42.0978 37.2219 45.9959 32.4125 45.9959C27.6052 45.9959 23.707 42.0978 23.707 37.2904C23.707 32.4831 27.6052 28.585 32.4125 28.585C37.2219 28.585 41.12 32.4831 41.12 37.2904Z",
    stroke: "#2C426B",
    strokeWidth: 1.54376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0592 37.5445C30.0592 38.8618 31.1264 39.929 32.4437 39.929C33.7609 39.929 34.8281 38.8618 34.8281 37.5445C34.8281 36.5037 34.1528 35.6258 33.2193 35.3008L33.2193 32.1874C33.2193 31.7611 32.871 31.4118 32.4437 31.4118C32.0144 31.4118 31.6641 31.7611 31.6641 32.1874L31.6641 35.3008C30.7326 35.6258 30.0592 36.5037 30.0592 37.5445Z",
    fill: "#2C426B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditScreen);
export default __webpack_public_path__ + "static/media/creditScreen.19dd22a7afa52a4072e3c691d9579c88.svg";
export { ForwardRef as ReactComponent };